module.exports = __webpack_public_path__ + "static/media/dealbinder.8b18188e.png";